import React from 'react';
import { useNavigate } from 'react-router-dom';

const ServerError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="container text-center d-flex align-items-center justify-content-center vh-100">
      <div className="notfound-content">
        <h1 className="display-1 fw-bold text-purple">500</h1>
        <h2 className="mb-3">Internal Server Error</h2>
        <p className="text-muted mb-4">
          Something went wrong. Please try again later.
        </p>
        <button className="btn btn-purple btn-lg" onClick={() => navigate('/')}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default ServerError;
